<template>
  <el-container class="callDetailVail">
    <el-header class="header-style">
      <el-divider content-position="left">通话详单</el-divider>
      <el-row class="mb-10" :gutter="10">
        <el-col :span="18">
          <el-select
            clearable
            v-model="searchArr.seat_number"
            filterable
            remote
            reserve-keyword
            placeholder="输入姓名搜素"
            size="mini"
            :remote-method="remoteMethod"
            :loading="loading"
            @change="handleUserChange"
          >
            <el-option
              v-for="user in users"
              :key="user.id"
              :label="user.username"
              :value="user.seat_number"
            >
            </el-option>
          </el-select>
          <el-date-picker
            v-model="searchArr.fwd_start_time"
            :picker-options="ysyTypeInPickerOptions"
            size="mini"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd"
            start-placeholder="呼叫开始日期"
            end-placeholder="结束日期"
            @change="handleFwdStartChange"
          ></el-date-picker>
          <el-popover placement="bottom-start" v-model="visible" width="320">
            <el-form :model="searchArr" ref="searchForm" label-width="80px">
              <el-form-item label="主叫号码" prop="caller">
                <el-input
                  style="width: 173px"
                  v-model="searchArr.caller"
                  placeholder="输入主叫号码查询"
                  size="mini"
                ></el-input>
              </el-form-item>
              <el-form-item label="被叫号码" prop="callee">
                <el-input
                  style="width: 173px"
                  v-model="searchArr.callee"
                  placeholder="输入被叫号码查询"
                  size="mini"
                ></el-input>
              </el-form-item>
              <el-form-item label="时长" prop="billsec">
                <el-select
                  v-model="searchArr.billsec"
                  placeholder="选择时长查询"
                  size="mini"
                >
                  <el-option label="1-30s" :value="1"></el-option>
                  <el-option label="30-60s" :value="2"></el-option>
                  <el-option label="60-120s" :value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="结果" prop="ul_fail_reason">
                <el-select
                  v-model="searchArr.ul_fail_reason"
                  placeholder="选择结果查询"
                  size="mini"
                >
                  <el-option label="正常挂机" value="HangUp"></el-option>
                  <el-option label="其他" value="other"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="来源" prop="from">
                <el-radio-group v-model="searchArr.from" size="mini">
                  <el-radio-button :label="1">企业火官网</el-radio-button>
                  <el-radio-button :label="2">企业火管理后台</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item>
                <el-button @click="resetForm('searchForm')" size="mini">重置</el-button>
                <el-button type="primary" @click="submitForm('searchForm')" size="mini"
                  >查询</el-button
                >
              </el-form-item>
            </el-form>
            <el-button slot="reference" size="mini">筛选</el-button>
          </el-popover>
        </el-col>
        <el-col :span="6">
          <div class="countSpan">
            <span>总数：{{ pageOption.total }} </span>
            <span style="margin-left: 0.2rem">时长：{{ billsecCount }} 秒</span>
          </div>
        </el-col>
        <!--       <el-col :span="6" class="text-r">
        <el-popconfirm title="确认切换吗？" @onConfirm="handleChangeLine">
          <el-button :disabled="line === '2'" slot="reference" type="primary" size="mini">切换</el-button>
        </el-popconfirm>
      </el-col> -->
      </el-row>
    </el-header>

    <el-main class="main-style">
      <el-table height="calc(100vh - 276px)" :data="pageData" size="mini" border style="width: 100%">
        <el-table-column label="姓名">
          <template slot-scope="scope">
            {{ scope.row.user ? scope.row.user.username : "测试" }}
          </template>
        </el-table-column>
        <el-table-column label="主叫号码">
          <template slot-scope="scope">
            {{ scope.row.caller }}
          </template>
        </el-table-column>
        <el-table-column label="被叫号码">
          <template slot-scope="scope">
            {{ scope.row.callee }}
          </template>
        </el-table-column>
        <el-table-column label="通话状态">
          <template slot-scope="scope">
            <el-tooltip
              v-if="scope.row.ul_fail_reason"
              :content="scope.row.ul_fail_reason"
              placement="top"
            >
              <span>{{ scope.row.ul_fail_reason }}</span>
            </el-tooltip>
            <span v-else>待处理</span>
          </template>
        </el-table-column>
        <el-table-column label="时长（秒）">
          <template slot-scope="scope">
            <span>{{ scope.row.billsec }}</span>
            <i
              v-if="scope.row.record_flag === 1"
              style="color: #5cb6ff; font-size: 0.4rem; cursor: pointer"
              class="el-icon-mic"
              @click="play(scope.row.file_storage, scope.row.record_file_download_url)"
            ></i>
            <i
              v-if="scope.row.record_flag === 1"
              style="color: #5cb6ff; font-size: 0.4rem; cursor: pointer"
              class="el-icon-download"
              @click="
                download(scope.row.file_storage, scope.row.record_file_download_url)
              "
            ></i>
          </template>
        </el-table-column>
        <el-table-column label="呼叫时间" width="140">
          <template slot-scope="scope">
            <!-- {{ scope.row.fwd_start_time }} -->
            <date-formatter :date-value="scope.row.fwd_start_time"></date-formatter>
          </template>
        </el-table-column>
        <el-table-column label="来源">
          <template slot-scope="scope">
            <span v-if="scope.row.from === 2">企业火管理后台</span>
            <span v-if="scope.row.from === 1">企业火官网</span>
          </template>
        </el-table-column>
      </el-table>
    </el-main>

    <el-footer class="footer-style">
      <el-pagination
        background
        class="mt-10 text-r"
        layout="sizes, total, prev, pager, next, jumper"
        :hide-on-single-page="false"
        :current-page="pageOption.currentPage"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageOption.pageSize"
        :total="pageOption.total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      >
      </el-pagination>
    </el-footer>

    <el-dialog
      title="播放"
      :visible.sync="dialogPlayVisible"
      :before-close="dialogPlayVisibleBeforeClose"
    >
      <el-row class="playCon">
        <el-card class="card" :body-style="{ padding: '10px' }">
          <div id="waveform" ref="waveform"></div>
        </el-card>
        <div style="padding: 10px" id="wave-timeline" ref="wave-timeline"></div>
      </el-row>
      <div class="text-c">
        <el-button type="primary" @click="playMusic" size="mini">
          <i :class="[isPlay ? 'el-icon-video-pause' : 'el-icon-video-play']"></i>
          {{ isPlay ? "暂停" : "播放" }}
        </el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import WaveSurfer from "wavesurfer.js";
import Timeline from "wavesurfer.js/dist/plugin/wavesurfer.timeline.js";
import { fscDate } from "../../../static/mixins/fastChooseDate";
import DateFormatter from "common/DateFormatter";

export default {
  name: "CallDetailVail",
  mixins: [fscDate],
  components: { DateFormatter },
  data() {
    return {
      line: null,
      visible: false,
      billsecCount: 0,
      pageData: [],
      pageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },
      searchArr: {
        from: "",
        seat_number: "",
        fwd_start_time: "",
        caller: "",
        callee: "",
        ul_fail_reason: "",
        billsec: ""
      },
      users: [],
      loading: false,
      wavesurfer: null,
      dialogPlayVisible: false,
      isPlay: false,
    };
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }

      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    getRecords() {
      this.$axios
        .get("/api/admin/call_logs?page=" + this.pageOption.currentPage + '&pageSize=' + this.pageOption.pageSize + this.searchStr)
        .then((res) => {
          let { data } = res;
          if (data.code === 200) {
            this.pageData = data.data.records.data;
            this.pageOption.total = data.data.records.total;
            this.billsecCount = data.data.billsecSum;
            this.line = data.data.line;
          }
        });
    },
    resetForm(formName) {
      this.visible = false
      this.$refs[formName].resetFields();
      this.pageOption.currentPage = 1;
      this.getRecords();
    },
    submitForm(formName) {
      this.visible = false
      this.pageOption.currentPage = 1;
      this.getRecords();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getRecords();
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.getRecords();
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchUsers(query);
        }, 200);
      } else {
        this.users = [];
      }
    },
    searchUsers(query) {
      this.$axios.get("/api/admin/callLogs/searchUsers/" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.users = data.data;
        }
      });
    },
    handleUserChange(val) {
      this.pageOption.currentPage = 1;
      this.getRecords();
    },
    handleChangeLine() {
      this.$axios.post("/api/admin/callLogs/changeLine", { lineNum: "2" }).then((res) => {
        let { data } = res;
        if (data.code === 200) {
          this.$message.success(data.msg);
          this.line = "2";
        }
      });
    },
    download(isStorage, url) {
      if (!url) {
        this.$message.error("录音为空");
        return;
      }

      if (!isStorage) {
        window.open(url);
        return;
      }

      this.$axios.post("/api/admin/callLogs/getObject", { filePath: url }).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          window.open(data.data);
        }
      });
    },
    play(isStorage, url) {
      if (!url) {
        this.$message.error("录音为空");
        return;
      }

      if (!isStorage) {
        window.open(url);
        return;
      }

      this.$axios.post("/api/admin/callLogs/getObject", { filePath: url }).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.dialogPlayVisible = true;
          this.waveSurferInit(data.data);
        }
      });
    },
    waveSurferInit(src) {
      this.$nextTick(() => {
        this.wavesurfer = WaveSurfer.create({
          container: this.$refs.waveform,
          barWidth: 1,
          cursorColor: "black",
          progressColor: "blue",
          backend: "MediaElement",
          audioRate: "1",
          plugins: [
            Timeline.create({
              container: "#wave-timeline",
            }),
          ],
        });
        this.wavesurfer.load(src);
        let that = this;
        this.wavesurfer.on("finish", function () {
          that.isPlay = false;
        });
      });
    },
    playMusic() {
      this.wavesurfer.playPause.bind(this.wavesurfer)();
      this.isPlay = this.wavesurfer.isPlaying();
    },
    dialogPlayVisibleBeforeClose(done) {
      this.isPlay = false;
      this.wavesurfer.destroy();
      done();
    },
    handleFwdStartChange(val) {
      this.pageOption.currentPage = 1;
      this.getRecords();
    },
  },
  mounted() {
    this.getRecords();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';

.callDetailVail {
  marginLeft();
  max-height: 100vh;
  .header-style {
    z-index: 2;
    height: 98px !important;
    padding: 0px !important;
  }
  .main-style {
    z-index: 1;
    padding: 0px !important;
    overflow-y: auto;
  }
  .footer-style {
    text-align: right;
    .el-pagination {
      padding-top: 20px;
    }
  }

  .mb-10 {
    margin-bottom: 0.2rem;
  }

  .mt-10 {
    margin-top: 0.2rem;
  }

  .text-c {
    text-align: center;
  }

  .text-r {
    text-align: right;
  }

  .m-tabs-content {
    padding: 0 0.2rem 0 0.4rem;
  }
}

.el-form-item {
  margin-bottom: 0.1rem;
}

.el-range-editor.el-input__inner {
  padding: 0 0.2rem;
}

.m-cell {
  padding: 0.12rem 0.2rem;
}

.m-cell-td {
  padding: 0.12rem 0.28rem;
}

.countSpan {
  line-height: 0.56rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/call_detail_vail/CallDetailVail.vue